module.exports = __webpack_public_path__ + "static/media/practice-icon-blue.8e78a140.svg";